export type ZoneCell = {
  zone_id: string | number;
  id?: string | number;
  name?: string;
  color?: string;
  delivery_date?: string;
  total_weight?: number;
  client_cost?: number;
  by_kg?: number;
  weight_deal?: number;
  weight_return?: number;
  weight_movement?: number;
  di_ids?: any[];
  no_money?: boolean;
  class_name?: string;
  costs?: any;
};

/** Sort zone cells so the same zone_id lands in the same column index across dates. */
export function sortZoneCellsByGroupId<T extends { zone_id: string | number }>(cells: T[]): T[] {
  return cells.slice().sort((a, b) => Number(a.zone_id) - Number(b.zone_id));
}

function emptyZoneCell(template: ZoneCell, deliveryDate: string): ZoneCell {
  return {
    id: template.zone_id,
    zone_id: template.zone_id,
    name: template.name,
    color: template.color,
    delivery_date: deliveryDate,
    total_weight: 0,
    client_cost: 0,
    by_kg: 0,
    weight_deal: 0,
    weight_return: 0,
    weight_movement: 0,
    di_ids: [],
    no_money: false,
    class_name: '',
    costs: undefined,
  };
}

/**
 * Align every date row to one canonical zone-group column order.
 * Missing zones are filled with zeroed placeholders so index i is always the same zone.
 */
export function alignRowsByZoneGroupId<T extends ZoneCell>(rows: T[][]): T[][] {
  const templates: Record<string, ZoneCell> = {};
  rows.forEach((row) => {
    row.forEach((cell) => {
      const key = String(cell.zone_id);
      if (!templates[key]) {
        templates[key] = cell;
      }
    });
  });

  const zoneIds = Object.keys(templates).sort((a, b) => Number(a) - Number(b));

  return rows.map((row) => {
    const byZone: Record<string, T> = {};
    let deliveryDate = '';
    row.forEach((cell) => {
      byZone[String(cell.zone_id)] = cell;
      if (cell.delivery_date) {
        deliveryDate = String(cell.delivery_date);
      }
    });

    return zoneIds.map((zoneId) => {
      if (byZone[zoneId]) {
        return byZone[zoneId];
      }
      return emptyZoneCell(templates[zoneId], deliveryDate) as T;
    });
  });
}
